import { CommonService } from 'src/app/shared/services/common.service';
import { Injectable, NgZone } from '@angular/core';
// tslint:disable-next-line: max-line-length
// tslint:disable-next-line: max-line-length
import { AttachmentsClass, EmailClass } from '../models/common-class';
import { CompaniesClass } from '../models/companies-class';
import { PaymentsSplitClass } from '../models/payments-class';
import { ProductsClass } from '../models/products-class';
import { DownloadedFile, FilesClass } from '../models/uploads-class';
import { GlobalService } from './global.service';
import { AgeasService } from './ageas.service';
import { ImageService } from './image.service';
import { TranquilidadeService } from './tranquilidade.service';
import { UploadService } from './upload.service';
import { firstValueFrom } from 'rxjs';
import { CustomerService } from './customer.service';
import Swal from './swal-compat';
// import { ValidateNifService } from './validatenif.service';

// New focused services (facade pattern)
import { UtilityService } from './utility.service';
import { NotificationService } from './notification.service';
import { DialogManagementService } from './dialog-management.service';
import { FileHandlingService } from './file-handling.service';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  constructor(
    // Keep old dependencies for methods not yet migrated
    private uploadService: UploadService,
    private commonService: CommonService,
    public globalService: GlobalService,
    private ageasService: AgeasService,
    private imageService: ImageService,
    private customerService: CustomerService,
    private tranquilidadeService: TranquilidadeService,
    private ngZone: NgZone,
    // private validateNifService: ValidateNifService,

    // NEW: Focused services for facade pattern
    private utilityService: UtilityService,
    private notificationService: NotificationService,
    private dialogManagement: DialogManagementService,
    private fileHandling: FileHandlingService,
  ) {
    // A configuração do pdfjsLib foi movida para o método de pré-visualização para evitar carregamento inicial pesado
  }

  private getSwal() {
    return Promise.resolve(Swal);
  }

  // ✅ FACADE: Delegating to DialogManagementService
  async helpbutton(id: number) {
    return await this.dialogManagement.helpbutton(id);
  }

  // ✅ FACADE: Delegating to UtilityService
  generatePassword(): string {
    return this.utilityService.generatePassword();
  }

  // ✅ FACADE: Delegating to FileHandlingService
  retiraextensao(_type: string, filename): string {
    return this.fileHandling.retiraextensao(_type, filename);
  }

  // ✅ FACADE: Delegating to UtilityService
  configRoutes() {
    return this.utilityService.configRoutes();
  }

  // OLD implementation kept as reference
  configRoutes_OLD() {
    // this.routesConfigGlobal = new RoutesConfig();h
    this.globalService.routesConfigGlobal.HideHome = false;
    this.globalService.routesConfigGlobal.HideSimulations = true;
    this.globalService.routesConfigGlobal.HidePolicies = true;
    this.globalService.routesConfigGlobal.HideInsuranceclaims = true;
    this.globalService.routesConfigGlobal.HideContacts = false;

    this.globalService.routesConfigGlobal.HideSitemanagement =
      !this.globalService.loggedUserClass.Admin && !this.globalService.loggedUserClass.SiteManagement;
    this.globalService.routesConfigGlobal.HideCommercialarea =
      !this.globalService.loggedUserClass.Admin &&
      !this.globalService.loggedUserClass.SiteManagement &&
      !this.globalService.loggedUserClass.CommercialArea;
    this.globalService.routesConfigGlobal.HideClientarea =
      !this.globalService.loggedUserClass.Admin &&
      !this.globalService.loggedUserClass.SiteManagement &&
      !this.globalService.loggedUserClass.ClientArea;

    this.globalService.routesConfigGlobal.HideIntermediaryArea =
      !this.globalService.loggedUserClass.Admin &&
      !this.globalService.loggedUserClass.SiteManagement &&
      !this.globalService.loggedUserClass.IntermediaryArea;
  }

  // ✅ FACADE: Delegating to UtilityService
  idade(dateString): string {
    return this.utilityService.idade(dateString);
  }

  // ✅ FACADE: Delegating to FileHandlingService
  async download(row: FilesClass | any): Promise<void> {
    return this.fileHandling.download(row);
  }

  async downloadAsZip(files: (FilesClass | any)[], zipName?: string): Promise<void> {
    return this.fileHandling.downloadAsZip(files, zipName);
  }

  // OLD implementation kept as reference
  async download_OLD(row: FilesClass | any): Promise<void> {
    row.isWaitFile = true;

    try {
      if (!row.VirtualDoc) {
        if (!row.FilePath) throw new Error('Caminho do arquivo não fornecido');

        const file = await firstValueFrom(this.uploadService.download(row.FilePath));
        await this.uploadService.handleFile(file, row.DocumentName);
        return;
      }

      // Documentos AGEAS
      if (row.idCompanie === 2 && row.documentId) {
        const dados = await firstValueFrom(this.ageasService.AGEASdownload(row.PolicyNumber, row.documentId));
        const downloadedFile = new DownloadedFile(dados);
        const fileBlob = this.imageService.base64ToBlob(downloadedFile.document, downloadedFile.contentType);
        const fileURL = URL.createObjectURL(fileBlob);

        const newWindow = window.open(fileURL, '_blank');
        if (!newWindow) {
          (await this.getSwal()).fire(
            'Atenção',
            'O bloqueador de pop-ups está ativado. Por favor, permita pop-ups para este site.',
            'warning',
          );
        }

        return;
      }

      // Documentos Tranquilidade
      if (row.idCompanie === 3) {
        let blob: Blob;

        if (row.FilePath === 'Recibo') {
          blob = await firstValueFrom(
            this.tranquilidadeService.TranquilidadedownloadObterDocumentoRecibo(
              row.NrRecibo,
              row.ValorRecibo,
              row.PolicyNumber,
              row.Tipo,
            ),
          );
        } else if (row.FilePath === 'CartaVerde') {
          blob = await firstValueFrom(
            this.tranquilidadeService.TranquilidadedownloadObterDocumentoCartaVerde(row.NrRecibo, row.PolicyNumber, ''),
          );
        } else {
          throw new Error('Tipo de documento desconhecido para Tranquilidade');
        }

        const file = new File([blob], `${row.DocumentName}.pdf`, { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');
      }
    } catch (error) {
      console.error(error);
      (await this.getSwal()).fire(
        'Atenção',
        'Ficheiro desconhecido ou danificado, por favor, tente novamente.',
        'warning',
      );
    } finally {
      row.isWaitFile = false;
    }
  }

  async downloadBK(row: FilesClass): Promise<any> {
    return new Promise((resolve, reject) => {
      let fileURL: string = '';
      row.isWaitFile = true;

      if (!row.VirtualDoc) {
        if (!row.FilePath) {
          reject('Caminho do arquivo não fornecido');
          row.isWaitFile = false;
          return;
        }

        row.isWaitFile = true;
        let f: any;
        this.uploadService.download(row.FilePath).subscribe({
          next: async (res: any) => {
            f = res;
          },
          error: async error => {
            row.isWaitFile = false;
            console.log(error);
            (await this.getSwal()).fire(
              'Atenção',
              'Ficheiro desconhecido ou danificado, por favor, tente novamente.',
              'warning',
            );
          },
          complete: async () => {
            row.isWaitFile = false;
            try {
              if (f !== '') {
                let downloadName = row.Description || row.DocumentName || 'documento';
                const extMatch = (row.FilePath || row.DocumentName || '').match(/\.([a-zA-Z0-9]+)(?:[?#]|$)/);
                const ext = extMatch ? `.${extMatch[1]}` : '';
                if (ext && !downloadName.toLowerCase().endsWith(ext.toLowerCase())) {
                  downloadName = `${downloadName}${ext}`;
                }
                await this.uploadService.handleFile(f, downloadName);
              }
            } catch (error) {
              row.isWaitFile = false;
              console.log(error);
            }
          },
        });
      } else {
        if (row.idCompanie === 2 && row.documentId) {
          this.ageasService.AGEASdownload(row.PolicyNumber, row.documentId).subscribe({
            next: async dados => {
              const downloadedFile = new DownloadedFile(dados);
              const fileBlob = this.imageService.base64ToBlob(downloadedFile.document, downloadedFile.contentType);
              fileURL = window.URL.createObjectURL(fileBlob);

              // Abrir o arquivo em uma nova janela
              const newWindow = window.open(fileURL, '_blank');
              if (!newWindow) {
                (await this.getSwal()).fire(
                  'Atenção',
                  'O bloqueador de pop-ups está ativado. Por favor, permita pop-ups para este site.',
                  'warning',
                );
              }
            },
            error: async error => {
              row.isWaitFile = false;
              console.log(error);
              (await this.getSwal()).fire(
                'Atenção',
                'Ficheiro desconhecido ou danificado, por favor, tente novamente.',
                'warning',
              );
            },
            complete: async () => {
              row.isWaitFile = false;
              resolve(fileURL);
            },
          });
        } else if (row.idCompanie === 3) {
          // Criando um Observer
          const observer = {
            next: (dados: Blob) => {
              const file = new File([dados], row.DocumentName + '.pdf', { type: 'application/pdf' });

              // Faça algo com o arquivo, como exibir, salvar ou processar
              // Por exemplo, se você deseja abrir o PDF em uma nova aba do navegador:
              const fileURL = URL.createObjectURL(file);
              window.open(fileURL);
            },
            error: (error: any) => {
              row.isWaitFile = false;
              console.log(error);
              // Trate os erros aqui
            },
            complete: () => (row.isWaitFile = false),
          };

          if (row.FilePath === 'Recibo') {
            this.tranquilidadeService
              .TranquilidadedownloadObterDocumentoRecibo(row.NrRecibo, row.ValorRecibo, row.PolicyNumber, row.Tipo)
              .subscribe(observer);
            resolve(fileURL);
          }

          if (row.FilePath === 'CartaVerde') {
            this.tranquilidadeService
              .TranquilidadedownloadObterDocumentoCartaVerde(row.NrRecibo, row.PolicyNumber, '')
              .subscribe(observer);
            resolve(fileURL);
          }

          // Você pode tratar adequadamente o cenário para a idCompanie 3
        }
      }
    });
  }

  // ✅ FACADE: Delegating to FileHandlingService
  downloadFilePath(path: string, Filename: string) {
    return this.fileHandling.downloadFilePath(path, Filename);
  }

  // ✅ FACADE: Delegating to UtilityService (with NIF → isEmpresa conversion)
  PrimeiroUltimoNome(nome: string, nif: string): string {
    // Valida se é empresa usando UtilityService
    let isEmpresa = false;
    try {
      isEmpresa = !!this.utilityService?.isNIFEmpresa?.(nif);
    } catch {
      // Ignora erros e trata como particular
    }

    // Delega para UtilityService com flag correcto
    return this.utilityService.PrimeiroUltimoNome(nome, isEmpresa);
  }

  onChangeName(fullName: string, nif: string) {
    if (this.globalService.loggedUserClass?.customerClass) {
      this.globalService.loggedUserClass.customerClass.firstLastName = this.PrimeiroUltimoNome(fullName, nif);
    }
  }

  /**
   * Força scroll para o topo em múltiplos elementos comuns (Window, Mat-Drawer, etc.)
   * Usa um pequeno timeout para garantir que o layout estabilizou.
   */
  scrollToTop(behavior: ScrollBehavior = 'smooth') {
    const performScroll = () => {
      // Tentar window e document primeiro
      [window, document.documentElement, document.body].forEach(t => {
        try {
          (t as any).scrollTo({ top: 0, behavior });
          (t as any).scrollTop = 0;
        } catch (e) {
          (t as any).scrollTop = 0;
        }
      });

      // Procurar todos os mat-drawer-content e outros contentores comuns
      const selectors = [
        '.mat-drawer-content',
        'mat-drawer-content',
        '.app',
        '#app',
        '.mat-tab-body-wrapper',
        '.main-content',
        '.page-wrapper',
        '.widgets-grid',
      ];

      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          try {
            el.scrollTo({ top: 0, behavior });
            el.scrollTop = 0;
          } catch (e) {
            el.scrollTop = 0;
          }
        });
      });
    };

    // Executa imediatamente e novamente após 150ms
    performScroll();
    setTimeout(performScroll, 150);
  }

  async BICSWIFT(iban: string): Promise<string> {
    return new Promise(resolve => {
      let SWIFT: string;
      SWIFT = '';

      if (iban.length > 4) {
        this.commonService.GetCommonBankCod(iban.substring(0, 4)).subscribe({
          next: dados => (SWIFT = dados[0].BICSWIFT),
          error: async error => {
            console.log(error);
            return SWIFT;
          },
          complete: async () => {
            resolve(SWIFT);
          },
        });
      }
    });
  }

  async editCompanie(companiesClass: CompaniesClass) {
    return await this.dialogManagement.editCompanie(companiesClass);
  }

  // Refatoração de métodos antigos que ainda tinham código redundante
  async editProduct(productsClass: ProductsClass) {
    return await this.dialogManagement.editProduct(productsClass);
  }

  async addProduct() {
    return await this.dialogManagement.addProduct();
  }

  async editPaymentSplit(paymentsSplitClass: PaymentsSplitClass) {
    return await this.dialogManagement.editPaymentSplit(paymentsSplitClass);
  }

  async addPaymentSplit() {
    return await this.dialogManagement.addPaymentSplit();
  }

  async editHTMLText(texto: string): Promise<any> {
    return await this.dialogManagement.editHTMLText(texto);
  }

  async openDialogPrivacity(id: number) {
    return await this.dialogManagement.openDialogPrivacity(id);
  }

  // ✅ FACADE: Delegating to NotificationService
  PopupMessage(message: string, action: string, tipo: string) {
    return this.notificationService.PopupMessage(message, action, tipo);
  }

  // ✅ FACADE: Delegating to FileHandlingService
  async fileshare(row: FilesClass) {
    return this.fileHandling.fileshare(row);
  }

  // OLD implementation kept as reference (delegates to FileHandlingService)
  async fileshare_OLD(row: FilesClass) {
    return this.fileHandling.fileshare(row);
  }

  openGoogleMapsWithLocation(latitude: number, longitude: number) {
    const url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    window.open(url, '_blank');
  }

  getLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          this.openGoogleMapsWithLocation(latitude, longitude);
          // Faça algo com as coordenadas (latitude e longitude) aqui
          console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
        },
        error => {
          console.error('Erro ao obter a localização:', error);
        },
      );
    } else {
      console.error('Geolocalização não suportada neste navegador.');
    }
  }

  async shareSelectedFiles(files: FilesClass[]): Promise<void> {
    if (!files || files.length === 0) return;

    try {
      let Nome = '';
      let Email = '';

      const clienteId = files[0]?.idCustomer;
      if (clienteId) {
        const dadosCliente = await firstValueFrom(this.customerService.ClientAreaGetCustomer(clienteId));
        if (dadosCliente && dadosCliente[0]) {
          Nome = dadosCliente[0].Name || '';
          Email = dadosCliente[0].Email || '';
        }
      }

      // Escapar aspas para uso seguro em atributos HTML
      const safeNome = Nome.replace(/"/g, '&quot;');
      const safeEmail = Email.replace(/"/g, '&quot;');

      const result = await (
        await this.getSwal()
      ).fire({
        title: 'Partilhar Documentos',
        html: `
        <div style="font-size: 13px; flex-direction: column; width: 100%;">
          <div style="width: 100%; text-align: left;">
            <span style="font-weight: bold;">Nome:</span><br>
            <input id="swal-input1" value="${safeNome}"
              style="width: 100%; height: 36px; font-size: 14px; border: 1px solid #c4c4c4; border-radius: 4px; padding: 0 8px; box-sizing: border-box;">
          </div>
          <div style="width: 100%; text-align: left; margin-top: 10px;">
            <span style="font-weight: bold;">Email:</span><br>
            <input id="swal-input2" type="email" value="${safeEmail}"
              style="width: 100%; height: 36px; font-size: 14px; border: 1px solid #c4c4c4; border-radius: 4px; padding: 0 8px; box-sizing: border-box;">
          </div>
        </div>
      `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        width: '350px',
      });

      if (!result || !result.isConfirmed) return;

      // Ler valores capturados pelo sv-message antes de fechar o modal
      const htmlValues = result.htmlInputValues || {};
      const nome = htmlValues['swal-input1'] || Nome;
      const emailVal = htmlValues['swal-input2'] || Email;

      // Validar email
      if (!emailVal || !/\S+@\S+\.\S+/.test(emailVal)) {
        (await this.getSwal()).fire('Atenção', 'Email inválido!', 'warning');
        return;
      }

      const nomeCliente = nome.split(' ').slice(0, 1).concat(nome.split(' ').slice(-1)).join(' ');
      const email = new EmailClass();
      email.to = emailVal;
      email.subject = `Documentos`;
      email.bcc = '';
      email.NIF = '';
      email.text = '';
      email.attachments = [];

      email.html = `
            <p>Olá <b>${nomeCliente}</b>,</p>
            <p>Em resposta ao seu pedido, anexamos os documentos relativos ao seu seguro.</p>
            <p>Pode consultar ou guardar os ficheiros em anexo.</p>
            <p>Obrigado por utilizar a <b>Seguros Virtual</b>.<br>
            Estamos sempre disponíveis para ajudar.</p>
            <br>
            <p>Com os melhores cumprimentos,<br>
            <b>Hugo Capela – Seguros Virtual</b><br>
            🌐 <a href="https://segurosvirtual.pt">www.segurosvirtual.pt</a><br>
            📱 WhatsApp: +351 912 273 828</p>
            `.trim();

      for (const row of files) {
        const attachment = new AttachmentsClass();
        attachment.filename = row.DocumentName || row.Description;
        attachment.pathexternal = false;

        const isVirtual =
          row.VirtualDoc ||
          row.FilePath === 'Recibo' ||
          row.FilePath === 'CartaVerde' ||
          Number(row.idCompanie) === 2 ||
          Number(row.idCompanie) === 3;

        if (isVirtual) {
          try {
            const fileBlobResult = await this.fileHandling.getFileBlob(row);
            const blob = fileBlobResult?.blob;
            if (!blob) {
              throw new Error('Não foi possível obter o documento da seguradora.');
            }
            const buffer = await blob.arrayBuffer();
            attachment.filename = fileBlobResult.filename || row.Description || row.DocumentName || 'Documento.pdf';
            attachment.buffer = Buffer.from(buffer);
            attachment.contentType = blob.type || 'application/pdf';
            attachment.pathexternal = false;
          } catch (fileErr: any) {
            console.error('❌ [BaseService] Erro ao obter blob de documento virtual:', fileErr);
            (await this.getSwal()).fire(
              'Atenção',
              `Não foi possível obter o documento "${row.Description || row.DocumentName}" da seguradora para envio.`,
              'warning',
            );
            return;
          }
        } else {
          attachment.path = row.FilePath;
        }

        email.attachments.push(attachment);
      }

      this.commonService.SendEmail(email).subscribe({
        next: async () => {
          (await this.getSwal()).fire('Documentos Enviados!', 'Os documentos foram enviados com sucesso.', 'success');
        },
        error: async error => {
          (await this.getSwal()).fire('Erro!', 'Não foi possível enviar os documentos.', 'error');
          console.error(error);
        },
      });
    } catch (error) {
      console.error(error);
      (await this.getSwal()).fire('Erro!', 'Não foi possível enviar os documentos.', 'error');
    }
  }

  async downloadPrev(row: FilesClass, silent = false): Promise<string> {
    return new Promise((resolve, reject) => {
      let fileURL: string = '';
      row.isWaitFile = true;

      if (!row.VirtualDoc) {
        let rawPath =
          row.FilePath ||
          (row as any).filePath ||
          (row as any).DocumentPath ||
          (row as any).documentPath ||
          (row as any).path ||
          (row as any).Path ||
          '';

        if (!rawPath || !rawPath.trim()) {
          row.isWaitFile = false;
          row.previewType = 'error';
          row.previewURL = 'assets/icons/file-error.svg';
          return reject('Caminho do arquivo não fornecido');
        }

        // Normalizar barras: substituir \ por / e remover barras duplas
        rawPath = rawPath.replace(/\\/g, '/').replace(/\/\//g, '/');
        row.FilePath = rawPath;

        this.uploadService.download(rawPath).subscribe({
          next: async (res: any) => {
            if (!res || (res instanceof Blob && res.size === 0)) {
              row.isWaitFile = false;
              row.previewType = 'error';
              row.previewURL = 'assets/icons/file-error.svg';
              return reject('Ficheiro vazio ou não encontrado');
            }

            // Se já for um Blob (Angular HttpClient responseType: 'blob'), usamos diretamente
            const fileBlob = res instanceof Blob ? res : new Blob([res], { type: row.type || '' });

            // Se o objeto não tem type mas o blob tem, recuperamos do blob (importante para anexos antigos)
            if (!row.type && fileBlob.type) {
              row.type = fileBlob.type;
            }

            fileURL = URL.createObjectURL(fileBlob);

            await this.displayPreview(fileBlob, row);
            resolve(fileURL);
          },
          error: async error => {
            row.isWaitFile = false;
            row.previewType = 'error';
            row.previewURL = 'assets/icons/file-error.svg';
            console.error(
              '[downloadPrev] ❌ Erro no download:',
              error?.status,
              error?.statusText,
              '| FilePath:',
              row.FilePath,
            );
            // Só mostrar popup se não for um preview silencioso
            if (!silent) {
              (await this.getSwal()).fire('Atenção', 'Ficheiro desconhecido ou danificado.', 'warning');
            }
            reject(error);
          },
          complete: async () => {
            row.isWaitFile = false;
          },
        });
      } else {
        row.isWaitFile = false;
        reject('VirtualDoc não suportado');
      }
    });
  }

  async displayPreview(fileURL: string | Blob, row: FilesClass): Promise<void> {
    try {
      if (!fileURL) {
        row.previewURL = 'assets/icons/file-error.svg'; // Ícone de erro
        row.previewType = 'error';
        return;
      }

      // Determine MIME type category
      const extension = row.DocumentName?.split('.').pop()?.trim().toLowerCase() || '';
      const isTextExt = [
        'txt',
        'js',
        'ts',
        'sql',
        'json',
        'xml',
        'html',
        'css',
        'ini',
        'md',
        'sh',
        'bat',
        'log',
        'config',
      ].includes(extension);
      const isImageExt = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'svg', 'avif'].includes(extension);

      // Safe check for type (row.type might be null or undefined)
      const rowType = (row.type || '').trim().toLowerCase();

      const isImage = rowType.match(/^image\/(png|jpeg|jpg|bmp|gif|webp|avif|svg\+xml)$/) || isImageExt;
      const isText =
        rowType.match(
          /^(text\/.*|application\/javascript|application\/json|application\/xml|application\/sql|application\/x-sql)$/,
        ) || isTextExt;
      const isXLSX =
        rowType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        rowType === 'application/vnd.ms-excel' ||
        extension === 'xlsx' ||
        extension === 'xls';
      const isPDF = rowType === 'application/pdf' || extension === 'pdf' || rowType.includes('pdf');

      if (isPDF) {
        row.previewType = 'image';

        // Pré-visualização de PDF
        const pdfjsModule: any = await import('pdfjs-dist');
        const pdfLib = pdfjsModule.getDocument ? pdfjsModule : pdfjsModule.default;

        if (pdfLib && pdfLib.GlobalWorkerOptions) {
          pdfLib.GlobalWorkerOptions.workerSrc = `${window.location.origin}/assets/pdfjs/pdf.worker.min.js`;
        }

        if (!pdfLib || !pdfLib.getDocument) {
          throw new Error('PDF.js getDocument não encontrado na library importada');
        }

        // Converter para ArrayBuffer para evitar bloqueios de fetch/CORS/fake-worker no worker
        let pdfData: ArrayBuffer;
        if (fileURL instanceof Blob) {
          pdfData = await fileURL.arrayBuffer();
        } else if (typeof fileURL === 'string') {
          const resp = await fetch(fileURL);
          pdfData = await resp.arrayBuffer();
        } else {
          pdfData = fileURL as any;
        }

        const loadingTask = pdfLib.getDocument({ data: pdfData, verbosity: 0 });

        try {
          const pdf = await loadingTask.promise;

          const page = await pdf.getPage(1);

          const scale = 0.5;
          const viewport = page.getViewport({ scale });

          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          await page.render({ canvasContext: context, viewport, canvas }).promise;

          this.ngZone.run(() => {
            row.previewURL = canvas.toDataURL();
          });
        } catch (pdfErr: any) {
          console.error('❌ Erro ao renderizar PDF:', pdfErr?.message || pdfErr?.name || pdfErr, row.DocumentName);
          throw pdfErr; // Relançar para o catch principal
        }
      } else if (isImage) {
        row.previewType = 'image';
        // Pré-visualização de Imagens (PNG, JPG, BMP, WEBP, AVIF, etc.)
        let imageSource: string = fileURL instanceof Blob ? URL.createObjectURL(fileURL) : fileURL;

        const img = new Image();
        if (!(typeof imageSource === 'string' && imageSource.startsWith('blob:'))) {
          img.crossOrigin = 'anonymous';
        }
        img.src = imageSource;

        img.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
            context.drawImage(img, 0, 0);

            this.ngZone.run(() => {
              row.previewURL = canvas.toDataURL();
            });
          } catch (canvasErr) {
            this.ngZone.run(() => {
              row.previewURL = imageSource;
            });
          }
        };

        img.onerror = () => {
          console.warn('[displayPreview] Fallback direto de URL para imagem:', row.DocumentName);
          this.ngZone.run(() => {
            row.previewURL = imageSource;
          });
        };
      } else if (isXLSX) {
        row.previewType = 'text';
        // Pré-visualização de XLSX usando SheetJS (xlsx.js)
        const reader = new FileReader();
        reader.onload = async event => {
          try {
            const XLSX = await import('xlsx');
            const workbook = XLSX.read(event.target?.result as ArrayBuffer, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            this.ngZone.run(() => {
              row.previewContent = json
                .slice(0, 5)
                .map((row: any[]) => row.join(' | '))
                .join('\n');
              // Fallback for older components relying on previewURL for text (though incorrect usage)
              row.previewURL = row.previewContent;
            });
          } catch (error) {
            console.error('Erro ao processar XLSX:', error);
            row.previewURL = 'assets/icons/file-error.svg';
            row.previewType = 'error';
          }
        };
        reader.readAsArrayBuffer(fileURL as Blob);
      } else if (isText) {
        console.log('Detectado ficheiro de texto via MIME ou Extensão:', rowType, extension);
        row.previewType = 'text';

        // Garantir que temos um Blob — se fileURL for string (objectUrl), fazer fetch
        let blobSource: Blob;
        if (fileURL instanceof Blob) {
          blobSource = fileURL;
        } else {
          try {
            const response = await fetch(fileURL as string);
            blobSource = await response.blob();
          } catch (fetchErr) {
            console.error('[displayPreview] Erro ao converter objectUrl para Blob:', fetchErr);
            row.previewURL = 'assets/icons/file-error.svg';
            row.previewType = 'error';
            return;
          }
        }

        const reader = new FileReader();
        reader.onload = () => {
          this.ngZone.run(() => {
            console.log('Leitura de texto concluída. Tamanho:', (reader.result as string).length);
            row.previewContent = reader.result as string;
            row.previewType = 'text'; // Ensure type is set
            // Fallback for logic checks
            row.previewURL = 'assets/icons/file-placeholder.svg';
          });
        };
        reader.onerror = e => {
          console.error('Erro ao ler ficheiro de texto:', e);
          row.previewType = 'error';
        };
        reader.readAsText(blobSource);
      } else {
        // Ícone genérico para tipos não suportados
        row.previewURL = 'assets/icons/file-placeholder.svg';
        row.previewType = 'error'; // Or 'icon'
      }
    } catch (error) {
      console.error('[displayPreview] SILENT CATCH - Erro na renderização:', error);

      row.previewURL = 'assets/icons/file-error.svg';
      row.previewType = 'error';
    }
  }

  async documentoscotacaoPrev(doc: FilesClass): Promise<void> {
    await this.downloadPrev(doc)
      .then(_fileURL => {
        // Se o arquivo foi baixado e o preview gerado com sucesso, force a detecção de mudanças
        this.ngZone.run(() => {
          // Detecta mudanças no componente
        });
      })
      .catch(error => {
        console.log('Erro no download:', error);
        // Exibir mensagem de erro para o usuário, se necessário
        // (await this.getSwal()).fire('Erro', 'Ocorreu um erro ao carregar o documento.', 'error');
      });
  }

  /** Configuração: tamanho mínimo de token para considerar match (evita ruído tipo "de","a") */
  private readonly MIN_TOKEN_LEN = 3;

  /** Normaliza texto para comparação robusta (acentos, NBSP, hífens, aspas, espaços, case) */
  private norm(s?: string): string {
    return (s ?? '')
      .replace(/\u00A0/g, ' ') // NBSP -> espaço
      .replace(/[‐-‒–—―]/g, '-') // vários hífens -> '-'
      .replace(/[“”«»"']/g, '') // aspas
      .normalize('NFD') // separa acentos
      .replace(/[\u0300-\u036f]/g, '') // remove acentos
      .replace(/\s+/g, ' ') // colapsa espaços
      .trim()
      .toLowerCase();
  }

  /** Extrai o nome do ficheiro (preferência: documentName -> fileName -> Tabulador) */
  getFileNameForMatch(file: any): string {
    return file?.documentName || file?.fileName || file?.FileName || file?.Tabulador || '';
  }

  /** Divide CSV em tokens (vírgula/;), limpa e aplica threshold de tamanho */
  private csvTokens(csv?: string): string[] {
    return (csv ?? '')
      .split(/[,;]+/)
      .map(x => x.trim())
      .filter(x => x.length >= this.MIN_TOKEN_LEN);
  }

  /** Calcula “força” do match: se label contém token (ambos normalizados) => pontua pelo comprimento do token */
  private tokenScore(labelRaw: string, tokenRaw: string): number {
    const label = this.norm(labelRaw);
    const token = this.norm(tokenRaw);
    if (!label || !token) return 0;
    return label.includes(token) ? token.length : 0;
  }

  /** Lê tokens por companhia a partir de uma linha da estrutura */
  private structTokensByCompany(struct: any, idCompanie: number): string[] {
    if (idCompanie === 2) return this.csvTokens(struct?.AGEASCodes);
    if (idCompanie === 3) return this.csvTokens(struct?.TranquilidadeCodes);
    return [];
  }

  /** Escolhe a melhor linha da estrutura com base nos tokens e prioridade (comprimento > Order > primeiro) */
  chooseBestStructureByFilename(filesStructure: any[], idCompanie: number, filename: string): any | null {
    if (!Array.isArray(filesStructure) || !filename) return null;

    let best: { struct: any; score: number; token: string } | null = null;

    for (const struct of filesStructure) {
      const tokens = this.structTokensByCompany(struct, idCompanie);
      if (!tokens.length) continue;

      for (const t of tokens) {
        const score = this.tokenScore(filename, t);
        if (score <= 0) continue;

        if (!best || score > best.score) {
          best = { struct, score, token: t };
        } else if (best && score === best.score) {
          // desempate por Order (menor Order tem prioridade)
          const a = best.struct?.Order ?? Number.MAX_SAFE_INTEGER;
          const b = struct?.Order ?? Number.MAX_SAFE_INTEGER;
          if (b < a) best = { struct, score, token: t };
        }
      }
    }

    return best?.struct ?? null;
  }
}
